import React, { useMemo } from 'react'
import { actionAtom } from 'atoms/atoms'
import { useAtomValue } from 'jotai'
import { Sheet } from '@node-space/ui-components'
import { ActionIds } from 'types/types'
import { ChangePasswordForm } from './ChangePasswordForm'

interface ChangePasswordSheetProps {
  isSheetOpen: boolean
}

export const UserDetailsSheet = ({ isSheetOpen }: ChangePasswordSheetProps) => {
  const action = useAtomValue(actionAtom)
  const { onBack, onClose, header, subHeader } = action || {}

  const sheetContent = useMemo(() => {
    switch (action?.actionId) {
      case ActionIds.CHANGE_PASSWORD:
        return <ChangePasswordForm />
      default:
        return null
    }
  }, [action])

  return (
    <Sheet
      header={header}
      onBack={onBack}
      isOpen={isSheetOpen}
      onClose={onClose}
      subHeader={subHeader}
    >
      {sheetContent}
    </Sheet>
  )
}
